import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import FeedbackWidget from './FeedbackWidget';

export default function Layout() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-20">
        {/* Boundary for code-split routes — navbar stays visible while a page chunk loads. */}
        <Suspense fallback={<div className="flex items-center justify-center min-h-[60vh] text-stone-400 text-sm">Loading…</div>}>
          <Outlet />
        </Suspense>
      </main>
      <FeedbackWidget />
    </div>
  );
}
